import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skuLargeImagesFragment = `
    on ${QueryType.skus} {
        media {
            large {
                src
                alt
                height
                width
            }
        }
    }
`;

export const skuLargeImagesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skuLargeImagesFragment
    };
};
